import './simple-backdrop.scss';

interface SimpleBackdropProps {
  open: boolean;
}

export default function SimpleBackdrop(props: SimpleBackdropProps) {
  const { open } = props;

  if (!open) return null;

  return (
    <div className="SimpleBackdrop">
      <div
        className="SimpleBackdrop__Spinner"
        role="status"
        aria-label="Loading"
      />
    </div>
  );
}
